import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';

// All pages
import Home from './pages/Home.js';
import MarkdownPage from './components/md/MarkdownPage.js';

import { useDocTitle } from './components/CustomHook.js';
import { ConfigProvider, useConfig } from './context/ConfigContext.js'; // New Import

// This new component can access the config via the useConfig hook
const AppContent = () => {
  const config = useConfig(); // Use the hook
  useDocTitle(`${config.appName}${config.appNamePostfix}`); // Set title using the hook's return value

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:filename" element={<MarkdownPage />} />
      </Routes>
    </Router>
  );
}

function App() {
  
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    }

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  return (
    <ConfigProvider>
      <AppContent />
    </ConfigProvider>
  );
}

export default App;